import React, { useRef, useMemo, useState, useEffect } from 'react';
import classnames from 'classnames';
import { useIntl, getLocale } from 'umi';
import { SelectMultiple as SelectMultipleTea, Bubble } from 'tea-component';
import SelectButton from '@/pages/intelligence/pages/Compare/PcConsoleGames/components/SelectButton';
import { Props } from './types';
import './index.scss';
const SelectMultiple = (props: Props) => {
  const { formatMessage } = useIntl();
  const locale = getLocale();
  const {
    style,
    className,
    label,
    required = true,
    searchable = false,
    popupContainer: popupContainerOutter = document.body,
    options: optionsOuter = [],
    value: valueOuter,
    onChange,
    onOpenChange,
    ...restProps
  } = props;
  const popupContainer =
    popupContainerOutter || (() => document.querySelector(`.${bindClassName.current}`) as HTMLElement);

  const bindClassName = useRef(label?.replace(/\s/g, '') + Date.now().toString(36));

  const options = useMemo(() => {
    if (!Array.isArray(optionsOuter)) return [];
    return optionsOuter.map?.((item) => {
      const text = item?.text;
      return {
        value: item?.value,
        text: (
          item?.tooltipKey ?
            <Bubble
              dark
              content={<span>{formatMessage({ id: item?.tooltipKey || text })}</span>}>
              <p className="select-multiple-item">
                {item.icon && <img className="select-multiple-item-icon" src={item?.icon} />}
                <span className="select-multiple-item-text">{formatMessage({ id: item?.key || text })}</span>
              </p>
            </Bubble> :
            <p className="select-multiple-item">
              {item.icon && <img className="select-multiple-item-icon" src={item?.icon} />}
              <span className="select-multiple-item-text">{formatMessage({ id: item?.key || text })}</span>
            </p>
        ),
        label: formatMessage({ id: item?.key || text })
      };
    });
  }, [locale, optionsOuter]);

  const [value, setValue] = useState<string[]>([]);

  const handleChange = (payload: string[]) => {
    // 按optinos顺序排序
    const valueTmp = [...payload].sort((a, b) => {
      const aIndex = options?.findIndex((option) => option?.value === a);
      const bIndex = options?.findIndex((option) => option?.value === b);
      return aIndex - bIndex;
    });
    setValue(valueTmp);
  };

  const handleOpenChange = (payload: boolean) => {
    if (!payload) {
      let valueTmp = value;
      if (!valueTmp?.length && required) {
        valueTmp = options?.map((item) => item?.value);
      }
      onChange?.(valueTmp);
    }
    onOpenChange?.(payload);
  };

  useEffect(() => {
    const valueTmp = Array.isArray(valueOuter) ? valueOuter : [];
    setValue(valueTmp);
  }, [valueOuter]);

  return (
    <SelectMultipleTea
      {...restProps}
      style={style}
      className={classnames([bindClassName.current, className])}
      boxClassName="select-multiple-container"
      overlayClassName="select-multiple-container__overlay dbi-select-multiple-container__overlay"
      appearance="button"
      popupContainer={popupContainer}
      matchButtonWidth={false}
      closeOnScroll={false}
      positionFixed={false}
      staging={false}
      searchable={searchable}
      button={<SelectButton label={label} options={options} value={value} />}
      allOption={{
        value: 'All',
        text: formatMessage({ id: 'dbi_all' }),
      }}
      options={options}
      value={value}
      onChange={handleChange}
      onOpenChange={handleOpenChange}
    />
  );
};

export default SelectMultiple;
